import React from 'react';
import {
  RootDiv,
  HeaderAppBar,
  HeaderToolbar,
  HeaderLeftDiv,
  PositionDivLeft,
} from './homeNavBar.styles';
import { DrawerMenu } from '@screens/menu';
import router from 'next/router';
import { NavBarTitle } from '@screens/mekidocCart/styles/MekiDocCartMain.styles';
import { MekiLogo } from '@components/icons/LogoMeki';
import { getRoute } from '@utils/routes';
import Link from 'next/link';

interface MekiDocScreenNavBarProps {
  title: string;
  isDesktop: boolean;
}

export function MekiDocScreenNavBar({
  title,
  isDesktop,
}: MekiDocScreenNavBarProps) {
  const elevation = 1;

  return (
    <RootDiv>
      <HeaderAppBar color="primary" elevation={elevation}>
        <HeaderToolbar>
          <PositionDivLeft>
            <HeaderLeftDiv>
              <DrawerMenu />
            </HeaderLeftDiv>
          </PositionDivLeft>
          <NavBarTitle>
            {isDesktop ? (
              <Link href={getRoute('homeLoggedIn').toString()}>
                <MekiLogo height="24px" width="auto" fill="black" />
              </Link>
            ) : (
              title
            )}
          </NavBarTitle>
        </HeaderToolbar>
      </HeaderAppBar>
    </RootDiv>
  );
}
